module.exports = __webpack_public_path__ + "images/59be8a9202cef431495695fb0ce77de4.activeActivity.svg";